import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=11d26e7f&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d26e7f",
  null
  
)

export default component.exports